<template>

  <div 
    ref     = "split_container"
    class   = "d-flex flex-column"
  >

    <!-- Top -->
    <div :style="topStyle">
      <slot name="top"></slot>
    </div>

    <!-- Splitter -->
    <div 
      v-if    = "showSplitter"
      class   = "splitter"
    >
      <v-icon
        @mousedown    = "onPreviousYPositioned"
      >
        mdi-drag-horizontal-variant
      </v-icon>
    </div>

    <!-- Bottom -->
    <div :style="bottomStyle">
      <slot name="bottom"></slot>
    </div>

  </div>

</template>

<script>

export default {

  // #region Properties

  name:  'HorizontalSplitPane',
  props: {
    split:      Number,
    hideTop:    Boolean,
    hideBottom: Boolean
  },
  data() {
    return {
      isResizing:        false,
      previousYPosition: 0
    };
  },
  computed: {
    topStyle() {
      let height = this.split;

      if (this.hideTop) {
        height = 0;
      } else if (this.hideBottom) {
        height = 100;
      }

      return {
        'height': `${height}%`
      };
    },
    bottomStyle() {
      let height = 100 - this.split;

      if (this.hideBottom) {
        height = 0;
      } else if (this.hideTop) {
        height = 100;
      }

      return {
        'height': `${height}%`
      };
    },
    showSplitter() {
      return !(this.hideTop || this.hideBottom);
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onPreviousYPositioned(event) {
      this.isResizing = true;
      this.previousYPosition = event.clientY;

      document.body.style.cursor = 'ns-resize';
      window.addEventListener('mousemove', this.onResizing);
      window.addEventListener('mouseup', this.onResizeEnded);
    },

    onResizing(event) {
      if (!this.isResizing) {
        return;
      }

      const difference = event.clientY - this.previousYPosition;
      const height = this.$refs.split_container.offsetHeight;

      const percentDelta = (difference / height) * 100;
      const newSplit = Math.max(0, Math.min(100, this.split + percentDelta));
      this.$emit('resize', newSplit);
      
      this.previousYPosition = event.clientY;
    },

    onResizeEnded() {
      if (!this.isResizing) {
        return;
      }

      this.isResizing = false;

      document.body.style.cursor = 'default';
      window.removeEventListener('mousemove', this.onResizing);
      window.removeEventListener('mouseup', this.onResizeEnded);
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.splitter {
  overflow:   hidden;
  text-align: center;

  .v-icon {
    cursor:     ns-resize;
  }
}

</style>